/**
 * Directive: hoverTooltip
 */
angular.module('acme.common.directive.hoverTooltip', [])
    .directive('hoverTooltip', [function () {

        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'common/directives/hoverTooltip/hoverTooltip.tpl.html',
            scope: {
                elementToHover: '=',
                tooltipContents: '=',
                position: '=',
                longContentOnly: '='
            },

            link: function ($scope, $element, $attrs) {
                var self = $scope.hoverTooltip;

                $scope.getHoverElementWidth = function () {
                    return $element.find(".hoverElement").width();
                };

                $scope.getTooltipSize = function () {
                    return {x: $element.find(".hoveredTooltip").width(), y: $element.find(".hoveredTooltip").height()};
                };

                $scope.$watch($scope.getHoverElementWidth, function (newValue, oldValue) {
                    if ($scope.longContentOnly) { //when tooltip is for overflowing text only
                        var elementWidth = newValue;
                        var element = $element.find(".hoverElement");
                        var textLength = element[0].innerText.length;
                        var contentPercentage = textLength * 100 / elementWidth;

                        /* I couldn't get what would the width of the text alone be so if the number of characters
                        * is longer than 20% of the container width then it probably won't fit and we would need
                        * the tooltip to display the whole text */
                        if (contentPercentage > 20) {
                            //since this is called several times, remove style if it was previously added
                            element.removeClass("noTooltip");
                        } else {
                            //add style to not show the tooltip on hover
                            element.addClass("noTooltip");
                        }
                    }
                }, true);

                $scope.$watch($scope.getTooltipSize, function (newValue, oldValue) {
                    var element = $element.find(".hoveredTooltip")[0];
                    var position = $scope.position;
                    var offset = 9;
                    var height = newValue.y + offset;

                    if (position === 'top') {
                        element.style.top = '-' + height + 'px';
                    }

                    if (position === 'bottom') {
                        element.style.bottom = '-' + height + 'px';
                    }


                }, true);

            },

            controller: ['$scope', function ($scope) {
                $scope.hoverTooltip = {};

            }]

        };

    }]);